export const PaymentMethod = {
    ONLINE: 'ONLINE',
    OTHER: 'OTHER',
    FREE: 'FREE'
};
